import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {Box, Button, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

// TODO ensure icon or img are specified
export type GDGAppBarButtonProps = {
    id?: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    text: string;
    textColor?: string;
    icon?: IconProp;
    iconColor?: string;
    img?: string;
    disabled?: boolean;
};

export default function GDGAppBarButton(props: GDGAppBarButtonProps): JSX.Element {
    const {
        id = '',
        onClick,
        text,
        textColor = 'black',
        icon,
        iconColor = 'black',
        img = '',
        disabled = false,
    } = props;

    return (
        <Button id={id} onClick={onClick} disabled={disabled} sx={{opacity: disabled ? 0.5 : 1.0}}>
            {icon !== undefined &&
                <FontAwesomeIcon size="sm" color={iconColor} icon={icon}/>
            }
            {img !== '' &&
                <img src={img} alt="img" width="48x"/>
            }
            <Box component={'span'} sx={{ width: '5px' }}/>
            <Typography variant="button" sx={{ color: textColor, textTransform: 'none' }}>{text}</Typography>
        </Button>
    )
}

